import {IApplicationRootState} from "../../../applicationState";
import {
    portfolioPageCurrentTabInner,
    assetAllocationExpandedRowsInner,
    assetAllocationSelectedDateInner,
    assetAllocationSelectedProductInner,
    performanceExpandedRowsInner,
    performanceSelectedDateInner,
    performanceSelectedProductInner, performanceTypeInner
} from "./PortfolioReducer";

export function assetAllocationExpandedRows(state: IApplicationRootState) {
    return assetAllocationExpandedRowsInner(state.portfolioPageState);
}

export function assetAllocationSelectedDate(state: IApplicationRootState) {
    return assetAllocationSelectedDateInner(state.portfolioPageState);
}

export function assetAllocationSelectedProduct(state: IApplicationRootState) {
    return assetAllocationSelectedProductInner(state.portfolioPageState);
}

export function portfolioPageCurrentTab(state: IApplicationRootState) {
    return portfolioPageCurrentTabInner(state.portfolioPageState);
}

export function performanceExpandedRows(state: IApplicationRootState) {
    return performanceExpandedRowsInner(state.portfolioPageState);
}

export function performanceSelectedDate(state: IApplicationRootState) {
    return performanceSelectedDateInner(state.portfolioPageState);
}

export function performanceSelectedProduct(state: IApplicationRootState) {
    return performanceSelectedProductInner(state.portfolioPageState);
}

export function performanceType(state: IApplicationRootState) {
    return performanceTypeInner(state.portfolioPageState);
}